/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { Notifications } from "@orbital/games-frontend-library"

export default function stakeChecker(
  stake: string,
  maxBet: string,
  minBet: string,
  balance: string,
  precision: number,
  currency: string,
  handleNotification: any,
): boolean {
  const n = Number(stake)
  const maxLimit = Number(maxBet) * 3

  if (n > maxLimit) {
    return handleNotification(
      Notifications.maxStake + maxLimit.toFixed(precision) + " " + currency,
    )
  }
  if (n < Number(minBet)) {
    return handleNotification(
      Notifications.minStake + (+minBet).toFixed(precision) + " " + currency,
    )
  }
  if (n > Number(balance)) {
    return handleNotification(Notifications.notEnoughBalance)
  }
  return true
}
